import { Box, Divider, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
export const CompletedTask = _ref => {
  let {
    description,
    inputLabel,
    onClickEdit,
    isEditable = false,
    completedValue,
    children,
    dataHook,
    editButtonLabel,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.completedTaskContainer(dataHook),
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(Box, {
    marginTop: "SP2"
  }, description), isEditable && onClickEdit && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginTop: "SP2"
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    direction: "horizontal",
    marginTop: "SP2"
  }, /*#__PURE__*/React.createElement(Text, {
    ellipsis: true,
    size: "tiny",
    weight: "thin",
    secondary: true
  }, inputLabel), /*#__PURE__*/React.createElement(TextButton, {
    dataHook: dataHooks.completedTaskEditButton(dataHook),
    ellipsis: true,
    size: "tiny",
    weight: "normal",
    onClick: onClickEdit
  }, editButtonLabel)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginTop: "3px",
    width: "268px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal",
    ellipsis: true
  }, completedValue))), children);
};
//# sourceMappingURL=completed-task.js.map